import { CSSProperties } from 'react';

export type WaveDownIconProps = {
  fill: string;
  height: number | string;
  width: number | string;
  style?: CSSProperties;
};

const WaveDownIcon = ({ fill, height, width, ...props }: WaveDownIconProps) => (
  <svg height={height} width={width} {...props}>
    <g>
      <path
        d="M0,23Q40.059066666666666,1.993333333333331,46.221999999999994,2.299999999999997C55.46639999999999,2.7599999999999967,83.19959999999999,23.229999999999997,92.44399999999999,27.599999999999994S129.4216,44.62,138.666,46S175.6436,43.69999999999999,184.88799999999998,41.39999999999999S221.86559999999997,20.24,231.10999999999999,23S268.0876,62.1,277.332,69S314.3096,92,323.554,92S360.53159999999997,72.45,369.77599999999995,69S406.7536,60.95,415.998,57.5S452.9756,33.34999999999999,462.21999999999997,34.499999999999986S499.19759999999997,70.14999999999999,508.44199999999995,69Q514.6049333333333,68.23333333333333,554.664,23L554.664,115Q514.6049333333333,115,508.44199999999995,115C499.19759999999997,115,471.46439999999996,115,462.21999999999997,115S425.2424,115,415.998,115S379.02039999999994,115,369.77599999999995,115S332.79839999999996,115,323.554,115S286.5764,115,277.332,115S240.3544,115,231.10999999999999,115S194.13239999999996,115,184.88799999999998,115S147.91039999999998,115,138.666,115S101.68839999999999,115,92.44399999999999,115S55.46639999999999,115,46.221999999999994,115Q40.059066666666666,115,0,115Z"
        fill={fill}
      />
    </g>
  </svg>
);

export default WaveDownIcon;
